export default {"src":"/_next/static/media/Vermont.723e8bfc.svg","height":928,"width":800,"blurWidth":0,"blurHeight":0};